import { render, staticRenderFns } from "./PopupRemiconBook.vue?vue&type=template&id=c41d05d4"
import script from "./PopupRemiconBook.vue?vue&type=script&lang=js"
export * from "./PopupRemiconBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports